/**
 * @param sorted Values sorted in ascending order
 * @param share Share of the values below the result, from 0 to 1
 * @returns the value at the quantile, without interpolation
 */
export function quantile(sorted: ArrayLike<number>, share: number): number {
  return sorted[Math.floor(share * (sorted.length - 1))];
}
